import {
  tableState,
  tableMutations,
  tableActions,
  tableGetters
} from "@tt/vue-components";
import InventoryService from "@/services/InventoryService";
import skuFilter from "@/store/modules/synchronisationSku/filters/skuFilter";
import statusFilter from "@/store/modules/synchronisationSku/filters/statusFilter";
import targetFilter from "@/store/modules/synchronisationSku/filters/targetFilter";

const synchronisationSkuOverview = {
  requestController: null,
  namespaced: true,
  modules: {
    skuFilter,
    statusFilter,
    targetFilter
  },
  state: {
    ...tableState,
    entry: null,
  },
  mutations: {
    ...tableMutations,
    SET_ENTRY(state, entry) {
      state.entry = entry;
    }
  },
  actions: {
    ...tableActions,
    setEntry({ commit }, sku) {
      commit("SET_ENTRY", sku);
    },
    fetchItems({commit, state}, refresh = false) {
      if (refresh || state.items.length === 0) {
        commit("SET_LOADING", true);

        const params = {
          pagination: state.pagination,
          sorting: state.sorting,
          search: state.search
        };

        InventoryService.skuSyncs.list(params)
          .then(json => {
            if (json) {
              commit("SET_ITEMS", json);
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            commit("SET_LOADING", false);
          });
      }
    }
  },
  getters: {
    ...tableGetters
  }
};

export default synchronisationSkuOverview;
